import { safetyRolesList } from '../data/safetyRoles'
import { trainingProducts } from '../data/trainingProducts'
import {
  WorkerAnagrafica,
  WorkerCourse,
  WorkerCourseSource,
} from '../types/worker'

// Ruolo: explicit value, otherwise derived from the first legacy safety role
export function getWorkerRuolo(worker: WorkerAnagrafica): string {
  if (worker.ruolo) return worker.ruolo
  const first = worker.safetyRoles?.[0]
  if (!first) return ''
  return safetyRolesList.find((r) => r.value === first)?.label || first
}

export function isCourseExpired(course: Pick<WorkerCourse, 'expiryDate'>) {
  if (!course.expiryDate) return false
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return new Date(course.expiryDate) < today
}

export function formatItDate(date?: string): string {
  if (!date) return '-'
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return date
  return new Date(date).toLocaleDateString('it-IT')
}

export const courseSourceLabels: Record<WorkerCourseSource, string> = {
  diretta: 'Diretta',
  massiva: 'Diretta massiva',
  indiretta: 'Indiretta',
}

// Expiry = date of the course + validity years of the product ('' if none)
export function courseExpiryDate(productCode: string | undefined, date: string): string {
  const years = trainingProducts.find((p) => p.code === productCode)?.validityYears
  if (!years || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return ''
  const [y, m, d] = date.split('-').map(Number)
  const expiry = new Date(Date.UTC(y + years, m - 1, d))
  return expiry.toISOString().slice(0, 10)
}

export function validityLabel(productCode?: string): string {
  const years = trainingProducts.find((p) => p.code === productCode)?.validityYears
  if (!productCode) return ''
  if (!years) return 'Nessuna scadenza'
  return `Validità ${years} ${years === 1 ? 'anno' : 'anni'}`
}

export function certificateFileName(courseName: string): string {
  const slug = courseName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
  return `attestato_${slug || 'corso'}.pdf`
}
